<template>
  <div class="appdetail">
      <!-- 标题、按钮 -->
      <div class="appdetail-title">
        <div class="appdetail-title-top clearfix">
          <div class="app-buttons">
            <el-button
              icon="icon-save"
              class="btn-"
              type="primary"
              size="mini"
              @click="saveBtn"
            >
              <font>保存</font>
            </el-button>
          </div>
        </div>
      </div>
      <el-tabs class="appdetail-content" type="border-card" v-model="currentDetailTabsModel" @tab-click="tabClick">
          <el-tab-pane label="列表" name="列表">
          </el-tab-pane>
          <el-tab-pane label="详情" name="详情">
            <div class="appdetail-content" :style="{ height: 'calc(100vh - 205px)' }">
        <el-form
          inline-message
          :model="dictionarieForm"
          :rules="rules"
          ref="dictionarieForm"
          class="demo-user"
        >
          <div class="content-accordion">
            <el-collapse v-model="activeNames">
              <el-collapse-item title="基础信息" name="1">
                <el-row :gutter="30">
                  <el-col :span="8">
                    <el-form-item
                      label="类型编码"
                      prop="code"
                      label-width="100px"
                    >
                      <el-input v-model="dictionarieForm.code"> </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      label="类型名称"
                      prop="name"
                      label-width="100px"
                    >
                      <el-input v-model="dictionarieForm.name"> </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="排序" prop="sort" label-width="100px">
                      <el-input v-model="dictionarieForm.sort"> </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="30">
                  <el-col :span="24">
                    <el-form-item label="备注" prop="tips" label-width="100px">
                      <el-input
                        type="textarea"
                        row="2"
                        v-model="dictionarieForm.tips"
                      >
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-collapse-item>
              <el-collapse-item title="字典值列表" name="2">
                <div class="pull-right" style="position: absolute; top: 5px; right: 45px">
                  <el-button
                    type="success"
                    size="mini"
                    @click="addfield1"
                  >
                    <i class="icon-add"></i>
                    <font>新建行</font>
                  </el-button>
                </div>
                <el-table
                  :header-cell-style="rowClass"
                  :fig="true"
                  :data="dictionarieForm.subDicts"
                  row-key="ID"
                  border
                  stripe
                  max-height="350"
                  highlight-current-row
                  style="width: 100%"
                  @cell-click="iconOperation"
                  :default-sort="{
                    prop: 'dictionarieForm.subDicts',
                    order: 'descending',
                  }"
                >
                  <el-table-column prop="iconOperation" fixed width="50">
                    <template slot-scope="scope">
                      <div style="width: 50px">
                        <i class="el-icon-check" v-if="scope.row.isEditing"></i>
                        <i class="el-icon-edit" v-else></i>
                      </div>
                    </template>
                  </el-table-column>

                  <el-table-column
                    prop="sort"
                    label="排序"
                    sortable
                    width="120"
                  >
                    <template slot-scope="scope">
                      <el-form-item
                        :prop="'subDicts.' + scope.$index + '.sort'"
                        :rules="{
                          required: true,
                          message: '不能为空',
                          trigger: 'blur',
                        }"
                      >
                        <el-input v-if="scope.row.isEditing" size="small" v-model="scope.row.sort">
                        </el-input>
                        <span v-else :model="scope.$index+1">{{ scope.row.sort }}</span>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column width="50"></el-table-column> -->
                  <el-table-column prop="name" label="值名称" sortable>
                    <template slot-scope="scope">
                      <el-form-item
                        :prop="'subDicts.' + scope.$index + '.name'"
                        :rules="{
                          required: true,
                          message: '不能为空',
                          trigger: 'blur',
                        }"
                      >
                        <el-input
                          v-if="scope.row.isEditing"
                          size="small"
                          v-model="scope.row.name"
                          placeholder="请输入值名称"
                        >
                        </el-input>
                        <span v-else>{{ scope.row.name }}</span>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column prop="code" label="值代号" sortable>
                    <template slot-scope="scope">
                      <el-form-item
                        :prop="'subDicts.' + scope.$index + '.code'"
                        :rules="[
                          {
                            required: true,
                            message: '不能为空',
                            trigger: 'blur',
                          },
                        ]"
                      >
                        <el-input
                          v-if="scope.row.isEditing"
                          size="small"
                          v-model="scope.row.code"
                          placeholder="请输入值名称的代号，一般用数字表示"
                        >
                        </el-input>
                        <span v-else>{{ scope.row.code }}</span>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column
                    fixed="right"
                    label="操作"
                    width="120"
                  >
                    <template slot-scope="scope">
                      <el-button
                        @click="deleteRow(scope.$index, scope.row, 'tableList')"
                        type="text"
                        size="small"
                      >
                        <i class="icon-trash red"></i>
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-collapse-item>
            </el-collapse>
          </div>
        </el-form>
      </div>
          </el-tab-pane>
      </el-tabs>
  </div>
</template>

<script>

export default {
  name: "masks",
  components: {},

  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("必填"));
      } else {
        callback();
      }
    };

    return {
      currentDetailTabsModel:"详情",
      drawer: false,
      loading: false,
      basic_url: Config.dev_url,
      isok1: true,
      isok2: false,
      activeNames: ["1", "2", "3"], //手风琴数量
      //				labelPosition: 'top', //表格
      dialogVisible: false, //对话框
      rules: {
        code: [
          { required: true, message: "必填", trigger: "blur" },
          { trigger: "blur", validator: this.Validators.isWorknumber },
        ],
        name: [
          { required: true, message: "必填", trigger: "blur" },
          { validator: this.Validators.isSpecificKey, trigger: "blur" },
        ],
        sort: [
          {
            required: false,
            trigger: "blur",
            validator: this.Validators.isSpecificKey,
          },
        ],
        tips: [
          {
            required: false,
            trigger: "blur",
            validator: this.Validators.isSpecificKey,
          },
        ],
      },
      addtitle: true,
      index: 0,
      dictionarieForm: {
        subDicts: [],
      },
    };
  },
  methods: {
    rowClass({ row, rowIndex }) {
      return "text-align:center";
    },
    handleClick(tab, event) {},
    iconOperation(row, column, cell, event) {
      if (column.property === "iconOperation") {
        row.isEditing = !row.isEditing;
      }
    },
    //清空
    reset() {
      this.dictionarieForm = {
        code: "",
        name: "",
        tips: "",
        sort: "",
        subDicts: [],
      };
    },
    //添加内容时从父组件带过来的
    addBtn() {
      this.dictionarieForm.sort = 0;
      this.$store.commit("setmenuAndDrawer", true);
      this.dictionarieForm = {
        code: "",
        name: "",
        tips: "",
        sort: "",
        subDicts: [],
      };
      this.currentDetailTabsModel = "详情"
      this.addtitle = true;
      this.isok2 = false;
      this.isok1 = true;
    },
    //这是查看
    view(item) {
      this.currentDetailTabsModel = "详情"
      this.dictionarieForm = item;
      this.getupdateuserdesc();
      this.getcreateuserdesc();
      this.addtitle = false;
      this.isok2 = false;
      this.isok1 = true;
      var url = Config.dev_url + '/api-user/dicts/' + item.id;
      this.$axios.get(url, {}).then((res) => {
        this.dictionarieForm = res.data;
      }).catch((err) => {
      });
    },
    toggle(e) {
      if (this.isok1 == true) {
        this.maxDialog();
      } else {
        this.rebackDialog();
      }
    },
    maxDialog(e) {
      //定义大弹出框一个默认大小
      this.isok1 = false;
      this.isok2 = true;
      $(".mask_div").css("width", "100%");
      $(".mask_div").height(document.body.clientHeight - 60);
      $(".mask_div").css("top", "60px");
      $(".mask_divbg").css("top", "0px");
    },
    //还原按钮
    rebackDialog() {
      //大弹出框还原成默认大小
      this.isok1 = true;
      this.isok2 = false;
      $(".mask_div").css("width", "85%");
      $(".mask_div").css("height", "90%");
      $(".mask_div").css("top", "0px");
      $(".mask_divbg").css("top", "100px");
    },
    //保存users/saveOrUpdate
    saveBtn() {
      this.$refs.dictionarieForm.validate((valid) => {
        if (valid) {
          this.dictionarieForm.hidden = this.dictionarieForm.hidden ? 1 : 0;
          var dictionarieForm = this.dictionarieForm;
          var url = Config.dev_url + "/api-user/dicts/saveOrUpdate";
          this.$axios
            .post(url, this.dictionarieForm)
            .then((res) => {
              if (res.data.code == 0) {
                this.$message({
                  message: "保存成功",
                  type: "success",
                });
                // this.$refs["dictionarieForm"].resetFields();
              } else {
                this.$message({
                  //新加的异常后端返回提示消息
                  message: res.data.msg,
                  type: "warning",
                });
              }
            })
            .catch((err) => {});
        } else {
          this.$message({
            message: "有必填项未填写，请填写",
            type: "warning",
          });
        }
      });
    },
    addfield1() {
      this.$axios
        .get(Config.dev_url + "/api-user/users/currentMap", {})
        .then((res) => {
          this.enterby = res.data.id;
          var date = new Date();
          this.currentDate = this.$moment(date).format("YYYY-MM-DD  HH:mm:ss");
          this.index = this.index + 1;
          var obj = {
            sort: this.index,
            code: "",
            name: "",
            isEditing: true,
          };
          this.dictionarieForm.subDicts.push(obj);
        })
        .catch((err) => {});
    },
    //刪除新建行
    deleteRow(index, row, listName) {
      if (row.id) {
        var url = Config.dev_url + "/api-user/dicts/" + row.id;
        this.$confirm("确定删除此数据吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
          .then(({ value }) => {
            this.$axios
              .delete(url, {})
              .then((res) => {
                if (res.data.resp_code == 0) {
                  this.dictionarieForm.subDicts.splice(index, 1);
                  this.$message({
                    message: "删除成功",
                    type: "success",
                  });
                } else {
                  this.$message({
                    message: res.data.resp_msg,
                    type: "error",
                  });
                }
              })
              .catch((err) => {});
          })
          .catch(() => {});
      } else {
        this.dictionarieForm[TableName].splice(index, 1);
      }
    },

    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {
          console.log("取消关闭");
          $(".v-modal").hide();
        });
    },
    //tab选项卡点击
    tabClick(tab){
        if(tab.label == "列表"){
            this.$store.commit('setcurrentShowPage',1)
            this.$emit("requestData")
        }else{
            this.$store.commit('setcurrentShowPage',2)
        }
    },
    //获取创建人描述
    getcreateuserdesc() {
      if (!!this.dictionarieForm.createuser) {
        var url =
          Config.dev_url + "/api-user/users/" + this.dictionarieForm.createuser;
        this.$axios.get(url).then((res) => {
          this.$set(this.dictionarieForm, "createuserdesc", res.data.nickname);
        }).catch((err) => {
                });
      }
    },
    //获取修改人描述
    getupdateuserdesc() {
      if (!!this.dictionarieForm.updateuser) {
        var url =
          Config.dev_url + "/api-user/users/" + this.dictionarieForm.updateuser;
        this.$axios.get(url).then((res) => {
          this.$set(this.dictionarieForm, "updateuserdesc", res.data.nickname);
        }).catch((err) => {
                });
      }
    },
  },
  mounted() {

  },
  computed: {
    //当前左侧菜单选中的信息
    currentSelectMenuData() {
      return this.$store.state.currentSelectMenuData;
    },
    //当前登录人信息
    currentuser() {
      return this.$store.state.currentuser;
    },
  }
};
</script>

<style scoped>
#FHScrollbar {
  overflow-y: scroll;
}
</style>
